import api from '@/utils/api'

export const fetchPlan = (runner, params) => {
  return api.get(`/runners/${runner.id}/plan/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}

export const fetchWorkouts = (runner, params) => {
  return api.get(`/runners/${runner.id}/workouts/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const createWorkout = (runner, obj) => {
  return api.post(`/runners/${runner.id}/workouts/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const copyWorkoutsMonth = (runner, params) => {
  return api.post(`/runners/${runner.id}/workouts/copy_month/`, params)
    .then(resp => {
      return (resp.data)
    })
}

export const copyWorkoutsWeek = (runner, params) => {
  return api.post(`/runners/${runner.id}/workouts/copy_week/`, params)
    .then(resp => {
      return (resp.data)
    })
}
export const removeWorkoutsWeek = (runner, params) => {
  return api.post(`/runners/${runner.id}/workouts/remove_week/`, params)
    .then(resp => {
      return (resp.data)
    })
}

export const updateWorkout = (runner, obj) => {
  return api.put(`/runners/${runner.id}/workouts/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const doneWorkout = (runner, obj) => {
  return api.put(`/runners/${runner.id}/workouts/${obj.id}/workout_done/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const undoneWorkout = (runner, obj) => {
  return api.put(`/runners/${runner.id}/workouts/${obj.id}/workout_undone/`)
    .then(resp => {
      return (resp.data)
    })
}

export const doneWorkoutsWeek = (runner, params) => {
  return api.post(`/runners/${runner.id}/workouts/done_week/`, params)
    .then(resp => {
      return (resp.data)
    })
}

export const undoneWorkoutsWeek = (runner, params) => {
  return api.post(`/runners/${runner.id}/workouts/undone_week/`, params)
    .then(resp => {
      return (resp.data)
    })
}

export const deleteWorkout = (runner, obj) => {
  return api.delete(`/runners/${runner.id}/workouts/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const fetchRaces = (runner, params) => {
  return api.get(`/runners/${runner.id}/races/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const fetchRacesSimple = (runner, params) => {
  return api.get(`/runners/${runner.id}/races/simple/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const createRace = (runner, obj) => {
  return api.post(`/runners/${runner.id}/races/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const updateRace = (runner, obj) => {
  return api.put(`/runners/${runner.id}/races/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const doneRace = (runner, obj) => {
  return api.put(`/runners/${runner.id}/races/${obj.id}/race_done/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const deleteRace = (runner, obj) => {
  return api.delete(`/runners/${runner.id}/races/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const fetchActivities = (runner, params) => {
  return api.get(`/runners/${runner.id}/activities/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const createActivity = (runner, obj) => {
  return api.post(`/runners/${runner.id}/activities/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const updateActivity = (runner, obj) => {
  return api.put(`/runners/${runner.id}/activities/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const deleteActivity = (runner, obj) => {
  return api.delete(`/runners/${runner.id}/activities/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const fetchRecords = (runner, params) => {
  return api.get(`/runners/${runner.id}/records/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const createRecord = (runner, obj) => {
  return api.post(`/runners/${runner.id}/records/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const updateRecord = (runner, obj) => {
  return api.put(`/runners/${runner.id}/records/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const createComment = (runner, obj) => {
  return api.post(`/runners/${runner.id}/plan_comments/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const updateComment = (runner, obj) => {
  return api.put(`/runners/${runner.id}/plan_comments/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const deleteComment = (runner, obj) => {
  return api.delete(`/runners/${runner.id}/plan_comments/${obj.id}/`)
    .then(resp => {
      return (resp.data)
    })
}

export const fetchComments = (runner, params) => {
  return api.get(`/runners/${runner.id}/plan_comments/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}

export const openDay = (runner, date) => {
  return api.delete(`/runners/${runner.id}/days/${date.format('YYYY-MM-DD')}/`)
    .then(resp => {
      return (resp.data)
    })
}
export const closeDay = (runner, date) => {
  return api.post(`/runners/${runner.id}/days/`, {date: date.format('YYYY-MM-DD')})
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/plan/api.js